import { CheckFunction } from "../../../../../layouts/MainTenantconfig"

const { COMPANY_NAME: companyName, BASE_URL: base_url } = CheckFunction();

const LICENCE_ID = "";
const BASE_URL = base_url;

const APIS = {
  GET_OEM_DETAILS_BY_MAKE_CLASS: BASE_URL + "getOEMDetail?makeClass=",
  SAVE_UPDATE_OEM_DETAILS: BASE_URL + "saveOrUpdateOEMDetail",
  GET_BATTERY_OEM_DETAILS: BASE_URL + "getBatteryOemDetails",
  SAVE_UPDATE_BATTERY_ORM_DETAILS: BASE_URL + "saveOrUpdateBatteryOemDetail",
  SAVE_UPDATE_EVOEM_SCORECARD: BASE_URL + "saveOrUpdateEVOEMScorecardConfig",

  SAVE_UPDATE_COMMUNITY_PERSONAL: BASE_URL + "saveOrUpdateCommunityDetails",
  GET_ALL_COMMUNITY_FOR_PARENT_COMMUNITY: BASE_URL + "getAllCommunityForParentCommunity",
  GET_COMMUNITY_PERSONAL: BASE_URL + "getCommunityDetailsByCommunityId?communityId=",

  SAVE_UPDATE_ADDRESS: BASE_URL + "saveOrUpdateAddressDetails",
  GET_BANK_BRANCH_DETAIL: BASE_URL + "userDetails/codeDetail?code=",
  GET_ADDRESS_DETAIL_COMMUNITY: BASE_URL + "getAddressDetailByCommunityIdAndType?communityId=",
  SAVE_UPDATE_ACCOUNT_DETAILS_DEALER: BASE_URL + "saveOrUpdateAccountDetails",

  GET_COMMUNITY_ACCOUNT_DETAIL_BY_COMMUNITYID: BASE_URL + "getCommunityAccountDetail?communityId=",

  GET_COMMUNITY: BASE_URL + "getCommunityDetails?pageNumber=",
  DELETE_COMMUNITY: BASE_URL + "deleteCommunityInfoByCommunityId?communityId=",
  GET_COMMUNITY_COUNT: BASE_URL + "getCommunityDetailsCount?emailId=",
  MARK_COMMUNITY_AS_IMP: BASE_URL + "markCommunityImportant?communityId=",
  DOWNLOAD_COMMUNITY_REPORT_BY_DATE: BASE_URL + "downloadCommunityReport?startDate=",

  GET_COMMUNITY_PROFESSIONAL: BASE_URL + "getCommunityProfDetailsByCommunityId?communityId=",
  GET_DOCUMENT_DETAIL: BASE_URL + "getDocumentsList?pageNumber=",
  GET_BANK_DETAIL_COMMUNITY: BASE_URL + "getAccountDetailsByCommunityId?communityId=",
  SEND_COMPLETE_PROFILE_LINK: BASE_URL + "sendProfileCompletitionToMember?communityId=",
  SEND_WELCOME_MAIL: BASE_URL + "sendWelcomeMail?communityId=",
  SEND_DOCUMENT_LINK: BASE_URL + "sendDocsUploadLinkToMember?communityId=",
  UPLOAD_OTHER_DOCUMENTS: BASE_URL + "saveAndUploadFileAndDocDetailOther",
  GET_DOC_NAME_SEARCH: BASE_URL + "searchByDocName?search=",

  GET_MAPPING_DETAILS_FOR_AMU_AGENT: BASE_URL + "getMappingDetailsForAmuAgent?communityId=",
  SAVE_MAPPED_UNMAPPED_DEALER: BASE_URL + "mappedAndUnMappedDealer?parentCommunityId=",

  GET_DASHBOARD_DATA_FOR_AMU_AGENT_BY_DATE: BASE_URL + "getDashBoardDataForAmuAgent?communityId=",
  GET_DEALER_WISE_AGENT_PERFORMANCE_BY_DATE: BASE_URL + "getDealerWiseAgentPerformance?communityId=",
  GET_LEAD_AGEING_PERFROMANCE_FOR_AMU_AGENT: BASE_URL + "getLeadAgeingPerformanceForAmuAgent?communityId=",
  GET_AVG_TAT_GRAPH_FOR_AMU_AGENT: BASE_URL + "getAvgTatGraphForAmuAgent?communityId=",

  COM_LEAD_SAVE_USER: BASE_URL + "saveOrUpdateUserDetails",
  COM_LEAD_GET_USER: BASE_URL + "getUserDetailByUserId?userId=",
  COM_LEAD_GET_USER_LOAN: BASE_URL + "getLoanDetailsByLoanId?loanId=",
  PAN_AUTHENTICATION_API: BASE_URL + "karza/api/panAuthenticationCheck?userId=",
  COM_LEAD_SAVE_USER_BUSINESS: BASE_URL + "saveOrUpdateUserBusinessDetail",
  COM_LEAD_GET_USER_BUSINESS: BASE_URL + "getUserBusinessDetailByUserId?userId=",
  COM_LEAD_SAVE_USER_DIRECTOR: BASE_URL + "saveOrUpdateDirectorDetail",
  COM_LEAD_GET_USER_DIRECTOR_BY_USERID: BASE_URL + "getDirectorDetailByUserId?userId=",
  COM_LEAD_DELETE_USER_DIRECTOR: BASE_URL + "deleteDirectorDetailById?id=",
  COM_LEAD_SAVE_USER_ADDRESS: BASE_URL + "saveOrUpdateAddressDetailsBusiness",
  COM_LEAD_GET_USER_ADDRESS: BASE_URL + "getAddressDetailByUserIdAndType?userId=",
  COM_LEAD_SAVE_USER_LOAN: BASE_URL + "saveLoanDetails",
  GET_STORY_LINE: BASE_URL + "getLeadStoryLine?loanId=",
  LOAN_AMOUNT_CONFIG_API: BASE_URL + "getCreditConfigForLoan?lenderId=",
  SAVE_STORY_LINE: BASE_URL + "saveStoryLine",
  GET_DOCUMENT_DETAIL: BASE_URL + "getDocumentsList?pageNumber=",
  GET_DOC_NAME_SEARCH: BASE_URL + "searchByDocName?search=",
  UPLOAD_ZIP_FILE: BASE_URL + "uploadZipAndSaveUrl",
  SAVE_UPDATE_DOCUMENT: BASE_URL + "saveAndUploadFileAndDocDetail",
  GET_DOCUMENT_CONFIG: BASE_URL + "getDocConfigByPageEntryLicenseAndProduct?pageNumber=",
  GET_DOCUMENT_TABLE_COUNT: BASE_URL + "getDocConfigCountByLicenseAndProduct?licenseId=",
  UPLOAD_OTHER_DOCUMENTS: BASE_URL + "saveAndUploadFileAndDocDetailOther",
  COM_LEAD_SAVE_USER_SALARIED: BASE_URL + "saveSalariedDetails",
  COM_LEAD_GET_USER_SALARIED: BASE_URL + "getSalariedDetails?userId=",
  COM_LEAD_SAVE_USER_PROPERTY: BASE_URL + "saveOrUpdateHousePropertyDetail",
  COM_LEAD_GET_USER_PROPERTY_BY_USERID: BASE_URL + "getHousePropertyDetailByUserId?userId=",
  COM_LEAD_GET_USER_PROPERTY_BY_LOANID: BASE_URL + "getHousePropertyDetailByLoanId?loanId=",
  COM_LEAD_DELETE_USER_PROPERTY: BASE_URL + "deleteHousePropertyDetailById?id=",

  GET_LICENCE: BASE_URL + "getLicenseByPageNo?pageNumber=",
  GET_LICENCE_TABLE_COUNT: BASE_URL + "getLicenseCountByEmailAndMobileNo?emailId=",
  SAVE_UPLOAD_FILE_DOC_DETAILS: BASE_URL + "saveAndUploadFileAndDocDetail",
  SAVE_UPDATE_EVDEALER_SCORECARD: BASE_URL + "saveOrUpdateEVDealerScorecardConfig",
  SAVE_UPDATE_COMMUNITY_PAYOUT_CONFIG: BASE_URL + "saveOrUpdateCommunityPayoutConfig",
  GET_COMMUNITY_PAYOUT_DETAIL_BY_COMMUNITYID: BASE_URL + "getCommunityPayoutConfig?communityId=",
  GET_STATE_LIST_FOR_DEALER: BASE_URL + "getStateListAB",
  GET_DISTRICT_STATE_LIST_FOR_DEALER: BASE_URL + "getDistrictListAB?stateName=",
    SAVE_UPDATE_NPA_WEIGHTAGE: BASE_URL + 'saveOrUpdateNPAWeightage',

  CHANGE_PARENT_COMMUNITY: BASE_URL + "changeParentCommunityMember?emailId=",
    COM_GET_DASHBOARD_TREE: BASE_URL + "getCommunityTreeByCommunityId?level=3&communityId=",
      NEW_TREE_API: BASE_URL + "getParentCommunityMemberDetail?communityId=",
       GET_CHAPTER_DETAILS_BY_CHAPTER_ID: BASE_URL + "getChapterDetailsByChapterId?chapterId=",
         COM_GET_NUMBER_OF_MEMBERS: BASE_URL + "getNumberOfMembersAddedByUser?communityId=",
           COM_GET_NUMBER_OF_LEADS_GENERATED: BASE_URL + "getNumberOfLeadsGeneratedByUser?communityId=",
             COM_GET_LEADS_STATUS: BASE_URL + "getCommunityLeadsByStatus?communityId=",
               GET_COMMUNITY_DASHBOARD_DATA: BASE_URL + "getDashboardStatisticsByCommunityId?communityId=",
                 GET_ACTIVITY_API: BASE_URL + "getStatusActivityList?loanId=",

                   LENDER_GET_LOAN_LEADS: BASE_URL + "getLoanLeads?pageNumber=",
                     LENDER_GET_LOAN_LEAD_COUNT: BASE_URL + "getLoanLeadsCount?lenderId=",
                       SAVE_LENDER_COMMENTS: BASE_URL + "saveComments",
  ASSIGN_LENDER_API: BASE_URL + "changeLeadLenderAssignment?lenderId=",
  ASSIGN_EMPLOYEE_LOAN: BASE_URL + "assignEmployeeId?employeeId=",
  ASSIGN_LENDER_LIST_API: BASE_URL + "assginLenderList",
  GET_LENDER_LIST: BASE_URL + "getLenderForLead?loanId=",
  ASSIGN_LENDER_EMP: BASE_URL + "assignLenderEmployee?loanId=",
  GET_LENDER_EMPLOYEE: BASE_URL + "getEmployeesOfLender?lenderId=",
  DELETE_ADMIN_LEAD: BASE_URL + "deleteLead?userId=",
    GET_LENDER_COUNT: BASE_URL + "getListOfEntriesCount?emailId=",
    GET_LENDER: BASE_URL + "getListOfEntries?pageNo=",


  GET_USER_TABLE_COUNT: BASE_URL + "getAdminUsersCountByCountEmailAndMobile?emailId=",
  GET_USERS: BASE_URL + "getAdminUsersByCountEmailAndMobile?pageNumber=",
  GET_WORKFLOW: BASE_URL + "getWorkFlowByPageEntryLicenseAndLenderId?pageNumber=",
  COM_LEAD_GET_USER_BANK: BASE_URL + "getAccountDetailsByUserId?userId=",
  GENERATE_CUSTOM_LINK: BASE_URL + "generateCustomLink",
  GET_CUSTOM_LINK: BASE_URL + "getCustomLinkByLinkId?linkId=",
  GET_CUSTOM_LINK_BY_LOANID: BASE_URL + "getCustomLinkByLoanId?loanId=",

    GET_BANK_SEARCH_DATA_MATCHING: BASE_URL + "bank/getMatchingBankName?search=",
      GET_BANK_SEARCH_DATA_MATCHING_WITH_ID: BASE_URL + "bank/getMatchingBankNameWithId?search=",
  GET_NBFC_SEARCH_DATA_MATCHING_WITH_ID: BASE_URL + "nbfc/api/getMatchingNbfcs?search=",
  GET_WORKFLOW_TABLE_COUNT: BASE_URL + "getWorkFlowCountByPageEntryLicenseAndLenderId?lenderId=",

    SAVE_APPLICATION_STATUS: BASE_URL + "saveApplicationStatus?loanId=",
  DISBURSE_APPLICATION: BASE_URL + "disburseStatus?loanId=",
  APPROVE_APPLICATION: BASE_URL + "approveApplication",
  GET_LOAN_EMI: BASE_URL + "getLoanEmiByLoanId?loanId=",
  GET_LOAN_ACTIVITY: BASE_URL + "getStatusActivityList?loanId=",
  SAVE_STICKY_NOTES: BASE_URL + "saveOrUpdateStickyNotes?loanId=",
  GET_STICKY_NOTES: BASE_URL + "getStickyNotesByLoanId?loanId=",

  DELETE_TASKS: BASE_URL + "tasks/delete?id=",
  GET_TASKS: BASE_URL + "tasks/get?loanId=",
  SAVE_TASKS: BASE_URL + "tasks/save",
  UPDATE_TASKS: BASE_URL + "tasks/update",
    GET_EMI_DETAILS_API: BASE_URL + "getLoanEmiByLoanId?loanId=",

    GET_CRIF_DATA_BY_USER_ID: BASE_URL + "getCrifData?userId=",
  GET_AUTOMATION_DOC: BASE_URL + "getAutomationDocListByUserId?userId=",



  MAP_AUTOMATION_DOC: BASE_URL + "saveAutomationDoc",

  UPLOAD_ZIP_FILE: BASE_URL + "uploadZipAndSaveUrl",
  SAVE_UPDATE_DOCUMENT: BASE_URL + "saveAndUploadFileAndDocDetail",
  GET_DOCUMENT_CONFIG: BASE_URL + "getDocConfigByPageEntryLicenseAndProduct?pageNumber=",
  GET_DOCUMENT_TABLE_COUNT: BASE_URL + "getDocConfigCountByLicenseAndProduct?licenseId=",

  GET_COMMISSION_BY_LOANID: BASE_URL + "getByLoanId?loanId=",
  GET_TIME_SPENT: BASE_URL + "getTimeSpent?loanId=",
  SAVE_COMMISSION: BASE_URL + "saveOrUpdateCommissionDetails",
  START_OR_STOP_TIMER: BASE_URL + "startOrStopTimer?loanId=",
  UPDATE_COMMISSION_BY_LOANID: BASE_URL + "updateCommissionDetailByLoanId?loanId=",

  // comments 
  GET_COMMENTS: BASE_URL + "getComments?loanId=",
  DELETE_COMMENT: BASE_URL + "deleteComment?id=",
  READ_COMMENTS: BASE_URL + "makeCommentsReaded?loanId=",
  SAVE_LENDER_COMMENTS: BASE_URL + "saveComments",
  GET_ASSIGNED_LENDERS_BY_LOANID: BASE_URL + "getLenderForLead?loanId=",
  POKE: BASE_URL + "increaseReminderCount?id=",
  RESET_REMAINDER: BASE_URL + "resetReminderCount?loanId=",

  GET_SHEET_URL: BASE_URL + "createSheet?loanId=",

  // challenges 
  DEL_CHALLENGE: BASE_URL + "deleteChallenges?id=",
  GET_CHALLENGE: BASE_URL + "getChallenges?loanId=",
  SAVE_CHALLENGE: BASE_URL + "saveChallenges",

    GET_PRODUCT_OF_COMMUNITYID_BY_COMMUNITYID: BASE_URL + "getProductOfCommunityById?communityId=" ,


  GET_MAPPED_PRODUCT_DETAILS_BY_COMMUNITYID: BASE_URL + "getMappedProductDetails?communityId=" ,
  GET_UNMAPPED_PRODUCT_DETAILS_BY_COMMUNITYID: BASE_URL + "getUnMappedProductDetails?communityId=" ,
  SAVE_UPDATE_COMMUNIYT_TO_PRODUCT: BASE_URL + "saveOrUpdateCommunityToProduct" ,
    DELETE_COMMUNIYT_TO_PRODUCT: BASE_URL + "deleteCommunityToProduct?communityId=" ,

  GET_COMMUNITY_TOOEM_DETAILS_BY_ID: BASE_URL + "getCommunityToOemDetail?communityId=" ,
  GET_COMMUNITY_TOOEM_DETAILS_COUNT_BY_ID: BASE_URL + "getCommunityToOemDetailCount?communityId=" ,
  DELETE_COMMUNITY_TO_OEM_DETAILS: BASE_URL + "deleteCommunityToOemDetail?communityId=" ,
    GET_UNMAPPED_COMMUNITY_TOOEM_DETAILS_BY_ID: BASE_URL + "getUnMappedOemDetailsForCommunity?communityId=" ,
  GET_UNMAPPED_COMMUNITY_TOOEM_DETAILS_COUNT_BY_ID: BASE_URL + "getUnMappedOemDetailsForCommunityCount?communityId=" ,
  SAVE_UPDATE_COMMUNITY_TO_OEM_DETAILS: BASE_URL + "saveOrUpdateCommunityToOemDetail" ,
    GET_VEHICLE_TYPE_LIST_BY_COMMUNITY: BASE_URL + "getVehicleTypeListByCommunity?communityId=" ,
      GET_COMMUNITY_DASHBOARD_DATA_BY_ID_DATE: BASE_URL + "getCommunityDashBoardData?communityId=" ,
        GET_CONVERSION_OVERTIME_GRAPH_BYID: BASE_URL + "getConversionOverTimeGraph?communityId=" ,
  GET_TOP_PERFORMANCE_VEHICLE_DETAIL_BY_ID: BASE_URL + "getTopPerformingVehicleDetailByCommunityId?communityId=" ,
  GET_CONTRIBUTION_GRAPH_FOR_DEALER_BY_ID: BASE_URL + "getContributionGraphForDealer?communityId=" ,
  GET_AGENT_DASHBOARD_DETAIL_BY_ID: BASE_URL + "getAgentDashBoardDetail?communityId=" ,
  GET_SALES_LEAD_CONVERSION_STATS_BY_ID: BASE_URL + "getSalesLeadConversionStats?communityId=" ,


  SAVE_UPDATE_DOCUMENT_TEMP_CONFIG: BASE_URL + "saveOrUpdateDocumentTempConfig",
  GET_DOCUMENT_TEMPLIST_BY_PAGE_ENTRY: BASE_URL + "getDocumentTempListByPageEntry?pageNumber=",
  GET_DOCUMENT_TEMPCOUNT_BY_PAGE_ENTRY: BASE_URL + "getDocumentTempCountByPageEntry",
  DELETE_DOCUMENT_TEMP_BY_ID: BASE_URL + "deleteDocumentTempById?id=",
  SAVE_UPDATE_DOCUMENT_CONFIG: BASE_URL + "saveOrUpdateDocumentConfig",
  GET_DOC_CONFIG_BY_PAGE_ENTRY_LICENSENUMBER_AND_PRODUCT: BASE_URL + "getDocConfigByPageEntryLicenseAndProduct?pageNumber=",
  GET_DOC_CONFIG_COUNT_BY_LICENSENUMBER_AND_PRODUCT: BASE_URL + "getDocConfigCountByLicenseAndProduct?product=",
  DELETE_DOC_CONFIG_BY_ID: BASE_URL + "deleteDocConfigById?id=",
}

export {
  APIS,
  BASE_URL,
  LICENCE_ID
}